module.exports = __webpack_public_path__ + "img/9-Choco Brown 8210.jpg";